import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE_react__ from "react";
import * as __WEBPACK_EXTERNAL_MODULE__components_input_mjs_391b4652__ from "../components/input.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__hooks_use_debounce_callback_mjs_f5c70f70__ from "../hooks/use-debounce-callback.mjs";
function DebouncedInput({ value: initialValue, onChange, debounce = 500, ...props }) {
    const [value, setValue] = __WEBPACK_EXTERNAL_MODULE_react__.useState(initialValue);
    const debouncedOnChange = (0, __WEBPACK_EXTERNAL_MODULE__hooks_use_debounce_callback_mjs_f5c70f70__.useDebounceCallback)(onChange, debounce);
    __WEBPACK_EXTERNAL_MODULE_react__.useEffect(()=>{
        setValue(initialValue);
    }, [
        initialValue
    ]);
    __WEBPACK_EXTERNAL_MODULE_react__.useEffect(()=>{
        if (value !== initialValue) debouncedOnChange(value);
    }, [
        value,
        debouncedOnChange,
        initialValue
    ]);
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__components_input_mjs_391b4652__.Input, {
        ...props,
        value: value,
        onChange: (e)=>setValue(e.target.value)
    });
}
export { DebouncedInput };
